import { Company } from "../Model/Company";

export class GetCompanyList {

    constructor(records, total, offset, limit) {
        this.records = records;
        this.total = total;
        this.offset = offset;
        this.limit = limit;
    }

    static createFromResponseData(data) {
        return new GetCompanyList(
            data.records.map(record => {
                return Company.createFromResponseData(record);
            }),
            data.total,
            data.offset,
            data.limit
        );
    }
}
